import LocalImages from "assets/images/local-images";
import Content from "content/content";
import { ChangeEvent, FC, ReactNode, useRef, useState } from "react";

import InputError from "../../styles/input/InputError.styled";
import InputLabel from "../../styles/input/InputLabel.styled";
import Flag from "./components/Flag";
import Select from "./styles/Select.styled";
import SelectContainer from "./styles/SelectContainer";
import StyledPicker from "./styles/StyledPicker.styled";

interface PickerProps {
  id: string;
  label?: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value?: string | null;
  flagCode?: string;
  disabled?: boolean;
  placeholder?: string;
  options: ReactNode[];
}

const DEFAULT_PLACEHOLDER = "Select a country";

const Picker: FC<PickerProps> = ({
  id,
  label,
  disabled,
  value,
  error,
  flagCode,
  placeholder,
  onChange,
  onFocus,
  options,
}) => {
  const direction = Content.shared.instance.dir();
  const selectRef = useRef<HTMLSelectElement>(null);
  const images = LocalImages.shared.images;

  const [focused, setFocused] = useState(false);

  const onSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const onPickerClick = () => {
    selectRef.current?.click();
  };

  return (
    <StyledPicker
      id={id}
      error={error}
      focused={focused}
      onClick={onPickerClick}
    >
      <SelectContainer direction={direction} isLabelPadded={!!flagCode}>
        {label ? <InputLabel>{label}</InputLabel> : null}
        {flagCode ? <Flag codeAlpha2={flagCode} direction={direction} /> : null}
        <div className="separator" />
        <Select
          aria-label={label}
          focused={focused}
          error={error}
          onFocus={() => {
            setFocused(true);
            onFocus?.();
          }}
          onBlur={() => setFocused(false)}
          ref={selectRef}
          padded={!!flagCode}
          direction={direction}
          disabled={disabled}
          onChange={onSelectChange}
          value={value || DEFAULT_PLACEHOLDER}
        >
          <option value={DEFAULT_PLACEHOLDER} disabled>
            {placeholder || DEFAULT_PLACEHOLDER}
          </option>

          {options}
        </Select>

        <img
          className="select-chevron"
          alt="chevron down"
          src={images.icons.chevron.select}
        />
      </SelectContainer>
      {error ? <InputError>{error}</InputError> : null}
    </StyledPicker>
  );
};

export default Picker;
